import React from "react";

const GeneralFormError = ({ errorMessage }) => (
    <div className="error on stripe-error">{errorMessage}</div>
);

export default GeneralFormError;
